import dayjs from 'dayjs';
export const isBeforeNow = (date) => dayjs(date).isBefore(dayjs());
export const isSameDay = (dateA, dateB) => dayjs(dateA).isSame(dayjs(dateB), 'days');
export const formatDate = (date, dateFormat) => dayjs(date).format(dateFormat);
export const getDaysLeft = (date) => dayjs(date).diff(dayjs(), 'days');
export const getHoursLeft = (date) => dayjs(date).diff(dayjs(), 'hours');
